module.exports = __webpack_public_path__ + "static/media/evaluación_360.05cc9e12.jpg";